// Definición de defaults

export const defaultTipoExhorto: TipoExhortoProps = {
    idTipoExhorto:  0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface TipoExhortoProps   {
    idTipoExhorto:  number;
    descripcion:    string;
    activo:         boolean;
}